<!-- 工作待办 -->
<template>
  <div class='todo-work atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="工作项分类">
            <common-select ref="workClassify" placeholder="工作项分类" v-model="searchParam.workClassify" :list="workClassifyList" optLabel="label" optValue="value" clearable></common-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="完成情况">
            <common-select ref="status" placeholder="完成情况" v-model="searchParam.status" :list="statusList" optLabel="label" optValue="value" clearable></common-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="工作项目">
            <el-input v-model="searchParam.workItemContent" placeholder="工作项目" clearable></el-input>
          </el-form-item>
          <el-form-item class="flex-form-item" label="状态">
            <common-select ref="commitStatus" placeholder="状态" v-model="searchParam.commitStatus" :url="$api.common.getDict" :ajaxMethod="'get'" :params="{ItemType:'TodoWorkReleaseState'}" 
            :filterData="filterData" optLabel="itemDesc" optValue="itemValue" clearable></common-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="add" @click="add">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button plain type="downloadTemplate" @click="expandRowAll">{{expandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          resizable
          stripe
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="todoTable"
          @cell-click="expandRow"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
        >
          <vxe-table-column type='seq' width='55' align='center' title="序号"></vxe-table-column>
          <vxe-table-column field="workClassify" title="工作项分类" width="120" :edit-render="{enabled: workClassifyEditable, autofocus: '.el-input__inner'}">
            <template #default="{ row }">{{ formatWorkClassify(row.workClassify) }}</template>
            <template #edit="{row}">
              <el-select v-model="row.workClassify" @change="$refs.todoTable.updateStatus(scope)">
                <el-option v-for="item in workClassifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" width="120" :edit-render="{enabled: workItemContentEditable, autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">
                <el-tooltip v-if="row.source === 1" effect="dark" content="来源上级" placement="top-start">
                  <i class="el-icon-s-custom super-icon"></i>
                </el-tooltip>
                <span>{{row.workItemContent}}</span>
              </div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.workItemContent" maxlength="512"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wholeTarget" title="总目标" min-width="160" :edit-render="{enabled: wholeTargetEditable, autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.wholeTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.wholeTarget" maxlength="512"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="creationTime" title="创建时间" width="160">
            <template #default="{ row }">{{ row.creationTime? formatDate(new Date(row.creationTime), 'yyyy-MM-dd HH:mm:ss'):0 }}</template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" title="完成时间" width="135" :edit-render="{enabled: finishDateEditable, autofocus: '.el-input__inner'}">
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" value-format="yyyy-MM-dd" align="right" type="date" placeholder="选择日期"></el-date-picker>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" title="备注" min-width="160" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remark}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remark" maxlength="512"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="summary" title="总结" min-width="160" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.summary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.summary" maxlength="512"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="完成情况" width="100" show-overflow :edit-render="{autofocus: '.el-input__inner'}">
            <template #default="{ row }">
              {{ formatStatus(row.status) }}
            </template>
            <template #edit="{row}">
              <el-select v-model="row.status" @change="$refs.todoTable.updateStatus(scope)">
                <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="approveReason" title="审批意见" min-width="120" show-overflow>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.approveReason || '无'}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="commitStatus" title="提交状态" width="135" show-overflow>
            <template #default="{ row }">
              <el-tag
                v-if='row.commitStatus === 0'
                type="complete"
                effect="dark">
                已保存
              </el-tag>
              <el-tag
                v-if='row.commitStatus === 10'
                type="delay"
                effect="dark">
                已提交-未审核
              </el-tag>
              <el-tag
                v-if='row.commitStatus === 20'
                type="complete"
                effect="dark">
                发布完成
              </el-tag>
              <el-tag
                v-if='row.commitStatus === 30'
                type="close"
                effect="dark"
              >
                已驳回
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed="right" width='80' class-name='operation'>
            <template #default="scope">
              <div v-if="scope.row.commitStatus === 0 || scope.row.commitStatus === 30">
                <el-tooltip v-if="isHasMonth || isHasWeek" class='item' effect='dark' content='发布' placement="bottom">
                  <i class='icon-send' @click.stop='showPuslish({row: scope.row})'></i>
                </el-tooltip>
                <el-tooltip v-if="scope.row.source !== 1" class='item' effect='dark' content='删除' placement="bottom">
                  <i class='icon-close delete' @click.stop='deleteTip({row:scope.row})'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
        background
        :current-page.sync="page.pageIndex"
        :page-size.sync="page.pageSize"
        :total="total"
        height="100%"
        @page-change="handledPageChange"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
      </vxe-pager>
    </div>
    <common-dialog ref="addDialog" :title="dialogContent.title" width="600px" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="EditRow" :workClassifyList="workClassifyList" :statusList="statusList" @submitSuccess="getList(1)"></component>
      </template>
    </common-dialog>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>已删除的工作项不能撤回</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>

    <common-dialog ref="publishDialog" class="todowork-publish-dialog" title="发布" width="1000px" showClose :appendBody="true">
      <template slot="content">
        <publish :rowData="publishRow" @submitSuccess="getList(1)" :isHasMonth="isHasMonth" :isHasWeek="isHasWeek"></publish>
      </template>
    </common-dialog>
  </div>
</div>
</template>
<script>
  import XEUtils from 'xe-utils'
  export default {
    components: {
     selecter:() => import('@/component/global/customerSelect'),
     publish: () => import('./publishDialog.vue'),
    },
    name: "TodoWork",
    data() {
      return {
        id:'id',
        searchParam: {
          workClassify: '',
          workItemContent: '',
          status: '',
          commitStatus: '',
        },
        workClassifyList: [],
        statusList: [],
 
        tableData:[],
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total:0,
        dialogContent:{},
        showDelTip: false,
        row: {},
        errMap: 1,
        cacheEditJson: {},
        expandRowAllFlag: false,

        publishRow: {},

        workItemContentEditable: true,
        workClassifyEditable: true,
        wholeTargetEditable: true,
        finishDateEditable: true,
      }
    },
    computed: {
      isHasMonth() {
        return this.$auth(this, 'MonthWork', 'OEC.PersonalConsole');
      },
      isHasWeek() {
        return this.$auth(this, 'WeekWork', 'OEC.PersonalConsole');
      }
    },
    mounted() {
      this.getList(1);
      this.getWorkItemProcessStatusDict();
      this.getMonthWorkItemClassify();
    },
    methods: {
      filterData(res){
        return res && res.data && res.data.rows;
      },
      getList(page) {
        this.page.pageIndex = page;
        const pageParam= { pageIndex: this.page.pageIndex, pageSize: this.page.pageSize } ;
        let param = Object.assign(
          {},
          this.searchParam,
          {
            workClassify: this.searchParam.workClassify + '',
            status: this.searchParam.status + ''
          },
          pageParam
        );
        this.$ajax.post(this.$api.todoWork.list, param).then((res) => {
          if(res.code === 0) {
            this.tableData = res.data.data;
            this.total = res.data.total;
          }
        });
      },
      formatWorkClassify(workClassify) {
        const searchItem = this.workClassifyList.find(item => item.value == workClassify);
        return searchItem ? searchItem.label : '';
      },
      formatStatus(status) {
        const statusItem = this.statusList.find(item => item.value == status)
        return statusItem ? statusItem.label : '';
      },
      formatDate(value, format) {
        if (value) {
          return XEUtils.toDateString(value, format)
        }
        return '';
      },
      deleteTip({row}) {
        this.showDelTip = true;
        this.row = row;
      },
      del() {
        if(this.row.id) {
          this.$ajax.get(this.$api.todoWork.del, {id: this.row.id}).then(() => {
            this.$message.success('删除成功');
            this.getList(1);
          }).finally(() => {
            this.showDelTip = false;
          });
        }
      },
      handledPageChange({ currentPage }) {
        this.getList(currentPage);
      },
      add() {
        const addRow = {
          workClassify: undefined,
          workItemContent: "",
          wholeTarget: "",
          finishDate: null,
          remark: "",
          status: undefined,
          summary: "",
        };
        const userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {};
        addRow.resWkNo = userInfo.wkNo;
        addRow.resWkName = userInfo.wkName;
        this.$ajax.post(this.$api.todoWork.add, addRow).then(res => {
          if(res.code === 0){
            this.$message.success('新增成功');
            this.getList(1);
          }
        });
      },
      showPuslish({row}) {
        this.publishRow = typeof(row) == 'object' ? row : {};
        this.$refs.publishDialog.show();
      },
  
      // 工作项分类
      getMonthWorkItemClassify() {
        this.$ajax.get(this.$api.common.getDict, {ItemType:'MonthWorkItemClassify'}).then(res=>{
          if(res.code === 0){
            this.workClassifyList = [];
            res.data && res.data.rows.forEach(t => {
              this.workClassifyList.push({label: t.itemDesc, value: parseInt(t.itemValue)});
            });
            this.workClassifyList.sort((a, b) => a.value - b.value)
          }
        });
      },
      // 状态
      getWorkItemProcessStatusDict() {
        this.$ajax.get(this.$api.common.getDict, { ItemType:'WorkItemProcessStatus' }).then(res=>{
          if(res.code === 0){
            res.data.rows.forEach(t=>{
              if (t.itemValue == 40) return 0;
              this.statusList.push({label: t.itemDesc, value: parseInt(t.itemValue)});
            });
            this.statusList.sort((a, b) => a.value - b.value)
          }
        });
      },
      expandRow({row, rowIndex}) {
        if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.todoTable.updateData(this.tableData);
      },
      expandRowAll() {
        if (this.expandRowAllFlag) {
          this.tableData.forEach(val => {
            if (val.id){
              val.expandRowFlag = false;
            }
          });
        } else {
          this.tableData.forEach(val => {
            if (val.id){
              val.expandRowFlag = true;
            }
          });
        }
        this.expandRowAllFlag = !this.expandRowAllFlag;
        this.$refs.todoTable.updateData(this.tableData);

        this.$nextTick(() => {
          if (this.$refs.todoTable) {
            let scrollInfo = this.$refs.todoTable.getScroll();
            this.$refs.todoTable.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
          }
        });
      },

      editActived({row}) {
        if (row.source === 1) {
          this.workItemContentEditable = false;
          this.workClassifyEditable = false;
          this.wholeTargetEditable = false;
          this.finishDateEditable = false;
        } else {
          this.workItemContentEditable = true;
          this.workClassifyEditable = true;
          this.wholeTargetEditable = true;
          this.finishDateEditable = true;
        }
        if (this.errMap && (row.commitStatus === 0 || row.commitStatus === 30)) {
          const preVal = {
            workClassify: row.workClassify,
            workItemContent: row.workItemContent,
            wholeTarget: row.wholeTarget,
            finishDate: row.finishDate,
            remark: row.remark,
            status: row.status,
            summary: row.summary,
          };
          this.cacheEditJson = JSON.parse(JSON.stringify(preVal));
          return true;
        }
        return false;
      },

      async editClosed({row, rowIndex}) {
        this.workItemContentEditable = true;
        this.workClassifyEditable = true;
        this.wholeTargetEditable = true;
        this.finishDateEditable = true;
        
        this.errMap = null;
        const currVal = {
          workClassify: row.workClassify,
          workItemContent: row.workItemContent,
          wholeTarget: row.wholeTarget,
          finishDate: row.finishDate,
          remark: row.remark,
          status: row.status,
          summary: row.summary,
        };

        if (JSON.stringify(this.cacheEditJson) === JSON.stringify(currVal)) {
          this.errMap = 1;
          return;
        }
        this.errMap = await this.$refs.todoTable.validate(row).catch(errMap => errMap)
        if (!this.errMap) {
          this.errMap = 1;
          const params = {
            ...row
          };
          const userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {};
          params.resWkNo = userInfo.wkNo;
          params.resWkName = userInfo.wkName;
          this.$ajax.post(this.$api.todoWork.update, params).then(async() => {
            this.$message.success("保存成功");
            if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
            this.$refs.todoTable.updateData(this.tableData);
          });
        }
      },

    }
  }
</script>
<style lang="scss">
.todowork-publish-dialog .el-dialog {
  height: 85%;
}
</style>
<style scoped lang='scss'>
  .todo-work {
    height: 100%;
    .atb-content-bg {
      margin-top: 0px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
    .search {
      overflow: auto;
      .atb-input{
        .params-wrap{
          display: flex;
          .flex-form-item{
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode{
            align-self: flex-end;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete{
              width: 100%;
            }
          }
          .el-date-editor.el-input{
            width: 100%;
          }
        }
      }
    }
    .super-icon {
      color: $--color-primary;
      margin-right: 2px;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }
  body .atb-input .el-form-item .el-button.el-button--sync {
    background-color: #D3F6E8;
    border-color: #D3F6E8;
    color: #62D48D;
    width: 130px;
  }
</style>
